/** @jsx jsx */
import { jsx } from 'theme-ui';
import React, { useContext } from 'react';
import { PageContext } from '../../contexts/page';
import {
  Container, SiblingList, Sibling, SectionList, Section,
} from './section-nav-css';
import { getContentfulPageWithPath } from '../../contentful/page-lookup';

const SectionNav = () => {
  const { state: { sections }, parentId, pagePath } = useContext(PageContext);
  const parentPagePaths = getContentfulPageWithPath(parentId);
  const parentPage = parentPagePaths ? parentPagePaths.find(
    ({ children }) => children && children.some(({ path }) => path === pagePath),
  ) : null;
  if (!parentPage) return null;
  return (
    <Container>
      <SiblingList>
        {parentPage.children.map(({ title, path }) => (
          <li key={title}>
            <Sibling to={path}>{title}</Sibling>
            {path === pagePath && (
              <>
                {sections.length > 0 && (
                  <SectionList>
                    {sections.map(({ id, title: sectionTitle }) => (
                      <li key={id}><Section to={`#${id}`}>{sectionTitle}</Section></li>
                    ))}
                  </SectionList>
                )}
              </>
            )}
          </li>
        ))}
      </SiblingList>
    </Container>
  );
};

export default SectionNav;
